// extracted by mini-css-extract-plugin
export default {"container":"FileTags_container__U7+ay","tag":"FileTags_tag__qh+Zp","tagName":"FileTags_tagName__vOemH"};